// extracted by mini-css-extract-plugin
module.exports = {"root":"zshXU","desktopHeader":"_1R04Y","mobileHeader":"_2hLqN","title":"_2zkvP","coverImageWrapper":"_3oTF7","coverImage":"oGh8q","textContent":"_356iK","button":"_1M2ub"};